export const COLUMNS = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  key: '1',
  align: 'center',
  width: 100,
  scopedSlots: {
    customRender: 'index'
  }
}, {
  slots: {
    title: '统计月份'
  },
  dataIndex: 'date',
  key: '3',
  align: 'center',
  width: 100
}, {
  slots: {
    title: '统计机构'
  },
  dataIndex: 'organizationName',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '报表名称'
  },
  dataIndex: 'peopleNum',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  key: '8',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 200
}];
export const data = [{
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  peopleNum: '234',
  grew: '5',
  licensesNum: '78',
  adminNum: '10',
  adminLicensesNum: '30',
  businessNum: '50',
  businessLicensesNum: '40',
  onBusinessNum: '100',
  onBusinessLicensesNum: '70',
  id: '1'
}];
export const COLUMNSINFO = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  key: '1',
  align: 'center',
  width: 100,
  scopedSlots: {
    customRender: 'index'
  }
}, {
  slots: {
    title: '产品大类'
  },
  dataIndex: 'typeName',
  key: '222',
  align: 'center'
}, {
  slots: {
    title: '人身险自营业务'
  },
  children: [{
    slots: {
      title: '新单保费金额（万元）'
    },
    dataIndex: 'premium',
    key: '3',
    width: 130,
    align: 'center'
  }, {
    slots: {
      title: '续单保费金额（万元）'
    },
    dataIndex: 'premium2',
    key: '5',
    width: 130,
    align: 'center'
  }, {
    slots: {
      title: '续单保费金额（万元）'
    },
    dataIndex: 'premium3',
    key: '6',
    width: 130,
    align: 'center'
  }, {
    slots: {
      title: '续单保费金额（万元）'
    },
    dataIndex: 'premium4',
    key: '7',
    width: 130,
    align: 'center'
  }]
}, {
  slots: {
    title: '第三方渠道数据'
  },
  children: [{
    slots: {
      title: '新单保费金额（万元）'
    },
    dataIndex: 'premium5',
    key: '8',
    width: 130,
    align: 'center'
  }, {
    slots: {
      title: '续单保费金额（万元）'
    },
    dataIndex: 'premium6',
    key: '9',
    width: 130,
    align: 'center'
  }, {
    slots: {
      title: '新单经纪佣金（万元）'
    },
    dataIndex: 'premium7',
    key: '10',
    width: 130,
    align: 'center'
  }, {
    slots: {
      title: '续单经纪佣金（万元）'
    },
    dataIndex: 'premium8',
    key: '11',
    width: 130,
    align: 'center'
  }]
}];
export const data2 = [{
  typeName: '定期寿险',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '两全寿险',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '终身寿险',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '年金保险',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '定期寿险（分红型）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '两全寿险（分红型）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '终身寿险（分红型）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '年金保险（分红型）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '年金保险（投资连结产品）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '年金保险（万能型）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '意外伤害保险（一年期以内）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '意外伤害保险（一年期业务）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '定期寿意外伤害保险（一年期以上）险',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '健康险（短期）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '健康险（长期）',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  typeName: '其他未分类',
  premium: '234',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}, {
  id: '2',
  typeName: '合计',
  premium: '3744',
  premium2: '',
  premium3: '',
  premium4: '',
  premium5: '',
  premium6: '',
  premium7: '',
  premium8: ''
}];